export const ExternalPaymentConstantCode =  {
    CheckKey: "EXTERNAL_TIMESTAMP",
};